// src/pages/CarregadoresVeiculares.js
import React from 'react';
import { Helmet } from 'react-helmet';
import ContactForm from '../components/ContactForm';
import './CarregadoresVeiculares.css';

// Importando as imagens que você fornecerá
import heroCharger from '../assets/chargers/hero-charger.png';
import homeCharger from '../assets/chargers/home-charger.jpg';
import condoCharger from '../assets/chargers/condo-charger.jpg';
import businessCharger from '../assets/chargers/business-charger.jpg';

const CarregadoresVeiculares = () => {
  // Schema de dados estruturados para SEO avançado
  const schemaData = {
    "@context": "https://schema.org",
    "@type": "Service",
    "serviceType": "Instalação de Carregadores para Veículos Elétricos",
    "provider": {
      "@type": "LocalBusiness",
      "name": "Primo Trade Solutions LTDA",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "Rua Dr. Pedro Ferreira, 333 - Sala 1206",
        "addressLocality": "Itajaí",
        "addressRegion": "SC",
        "postalCode": "88301-030",
        "addressCountry": "BR"
      },
      "telephone": "+55-11-97721-1739"
    },
    "areaServed": {
      "@type": "Country",
      "name": "Brasil"
    },
    "description": "Instalação profissional de carregadores e estações de recarga para carros elétricos Intelbras. Soluções para residências, condomínios e empresas.",
    "url": "https://www.primotradesolutions.com.br/carregadores-veiculares"
  };

  return (
    <div className="page-chargers">
      <Helmet>
        <title>Instalação de Carregadores Veiculares Intelbras | PTS</title>
        <meta name="description" content="Especialistas na instalação de carregadores para veículos elétricos Intelbras. Projetos para sua casa, condomínio ou frota empresarial. Peça seu orçamento." />
        <meta name="keywords" content="carregador veicular, estação de recarga, carro elétrico, intelbras, CVE, instalação carregador, wallbox" />
        <meta property="og:title" content="Carregadores Veiculares Intelbras - Instalação Profissional" />
        <meta property="og:description" content="Conecte-se ao futuro da mobilidade com as soluções de recarga da Intelbras instaladas pela PTS. Segurança e eficiência para sua residência ou negócio." />
        <meta property="og:url" content="https://www.primotradesolutions.com.br/carregadores-veiculares" />
        <script type="application/ld+json">{JSON.stringify(schemaData)}</script>
      </Helmet>

      {/* --- Bloco 1: Herói --- */}
      <section className="charger-hero-section" style={{ backgroundImage: `url(${heroCharger})` }}>
        <div className="container">
          <h1>Conecte-se ao Futuro da Mobilidade</h1>
          <p className="subtitle">Instalamos a solução completa de carregadores para veículos elétricos Intelbras, projetada para sua necessidade. Descubra o carregador ideal para você.</p>
          <a href="#contato" className="charger-cta">Simular Agora</a>
        </div>
      </section>

      {/* --- Bloco 2: Soluções Residenciais --- */}
      <section id="para-voce" className="charger-section content-image-section">
        <div className="container charger-grid">
          <div className="charger-text-content">
            <h2 className="section-title-left">PARA VOCÊ E SUA CASA</h2>
            <p>O <strong>CVE Home</strong> e o <strong>CVE Mini</strong> são as soluções perfeitas para sua residência ou vaga exclusiva. Com design moderno, discrição e a mais alta qualidade, você carrega seu carro na garagem com total segurança e praticidade, monitorando tudo pelo app.</p>
            <ul>
              <li><strong>Design Compacto e Moderno:</strong> Integra-se perfeitamente à sua garagem.</li>
              <li><strong>Segurança Avançada:</strong> Proteção contra surtos, sobrecarga e poeira (IP65).</li>
              <li><strong>Potência Ideal:</strong> Modelos de 7,4 kW que garantem uma recarga rápida e eficiente.</li>
            </ul>
            <a href="#contato" className="charger-cta-outline">Cadastre-se Aqui</a>
          </div>
          <div className="charger-image-content">
            <img src={homeCharger} alt="Carregador veicular Intelbras instalado em uma residência moderna" />
          </div>
        </div>
      </section>

      {/* --- Bloco 3: Soluções para Condomínios --- */}
      <section id="para-condominio" className="charger-section content-image-section reverse">
        <div className="container charger-grid">
          <div className="charger-image-content">
            <img src={condoCharger} alt="Estação de recarga Intelbras em estacionamento de condomínio" />
          </div>
          <div className="charger-text-content">
            <h2 className="section-title-left">PARA SEU CONDOMÍNIO</h2>
            <p>O <strong>CVE City</strong> é um ecossistema completo de gestão com funcionalidades ideais para o uso compartilhado em condomínios. Através de um cartão de acesso numerado ou app, os usuários liberam o carregamento, e o síndico obtém o rateio individual do consumo.</p>
            <ul>
              <li><strong>Gestão Completa:</strong> Aplicativo para gerenciamento e rateio de custos.</li>
              <li><strong>Controle de Acesso:</strong> Liberação via App ou cartões RFID para total controle.</li>
              <li><strong>Robusto e Potente:</strong> Modelos de 7,4 kW a 11 kW com conector tipo 2 e cabo de 4 metros.</li>
            </ul>
            <a href="#contato" className="charger-cta-outline">Cadastre-se Aqui</a>
          </div>
        </div>
      </section>

      {/* --- Bloco 4: Soluções Corporativas --- */}
      <section id="para-empresas" className="charger-section content-image-section">
        <div className="container charger-grid">
           <div className="charger-text-content">
            <h2 className="section-title-left">SOLUÇÕES CORPORATIVAS</h2>
            <p>O <strong>CVE Business</strong> conecta alta eficiência e um design diferenciado para estacionamentos privados, frotas empresariais ou estabelecimentos. Ofereça um diferencial para seus clientes e funcionários, ou gerencie a recarga da sua frota de forma inteligente.</p>
            <ul>
                <li><strong>Design Sofisticado:</strong> Display em vidro temperado, ideal para locais com grande circulação.</li>
                <li><strong>Flexibilidade de Instalação:</strong> Pode ser instalado na parede ou em pedestal.</li>
                <li><strong>Versatilidade:</strong> Versões de 7,4 kW e 22 kW para atender a qualquer demanda.</li>
            </ul>
            <a href="#contato" className="charger-cta-outline">Cadastre-se Aqui</a>
          </div>
          <div className="charger-image-content">
            <img src={businessCharger} alt="Carregadores para frotas de veículos elétricos empresariais" />
          </div>
        </div>
      </section>

      {/* --- Bloco 5: Formulário --- */}
      <section id="contato">
         <ContactForm />
      </section>
    </div>
  );
};

export default CarregadoresVeiculares;